import { render, staticRenderFns } from "./EditReport.vue?vue&type=template&id=2a8b7ef6&scoped=true&"
import script from "./EditReport.vue?vue&type=script&lang=ts&"
export * from "./EditReport.vue?vue&type=script&lang=ts&"
import style0 from "./EditReport.vue?vue&type=style&index=0&id=2a8b7ef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b7ef6",
  null
  
)

export default component.exports